import { connect } from 'react-redux';
import { FeatureToggle } from '@zola/zola-ui/src/components/FeatureToggle';

import type {
  FeatureFlagsAvailableFlagSetting,
  FeatureFlagsAvailableFlagSettings,
} from '@zola-helpers/client/dist/es/constants/navConstants';

import type { RootState } from '../../reducers';

import featureFlags, { FLAGS } from '../../util/featureFlags';

const mapStateToProps = (state: RootState) => ({
  userContext: state.user.userContext,
  product: 'NAV',
  productFlags: Object.keys(FLAGS).reduce((result, flag) => {
    const flagSettings: FeatureFlagsAvailableFlagSetting = {
      value: featureFlags.get(flag),
      ...FLAGS[flag as keyof typeof FLAGS],
    };

    return {
      ...result,
      [flag]: flagSettings,
    };
  }, {} as FeatureFlagsAvailableFlagSettings),
});

export default connect(mapStateToProps)(FeatureToggle);
